(ns teamoesterreich.admin-mode.toe-map-list.small-toe-table
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.view-state :as vstate]
            [reagent-material-ui.icons.call :as ic-call]
            [reagent-material-ui.icons.alternate-email :as ic-email]
            [reagent-material-ui.icons.edit :as ic-edit]
            [reagent-material-ui.icons.location-searching :as ic-location-searching]
            [reagent.core :as r]
            [teamoesterreich.util.log :as log]))



(defn get-sort-filter-rows [elms sort_ reverse_ ]
  ;(js/console.log "get-sort-filter-rows elms  " elms)
  (let [rows (if elms (mapv (fn [[k v]] (assoc v :index k)) elms) [])
        rows (sort-by #(get % (if sort_ sort_ "lastName")) rows)
        rows (if reverse_ (reverse rows) rows)
        ]
    rows))


(defn phone-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    ;(println "email-cell-renderer " cell-data)
    (r/as-element
      [:a {:href (str "phone:" cell-data) :title cell-data} [ic-call/call {:fontSize "small"}]])))

(defn email-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    ;(println "email-cell-renderer " cell-data)
    (r/as-element
      [:a {:href (str "mailto:" cell-data) :title cell-data} [ic-email/alternate-email {:fontSize "small"}]])))


(defn edit-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [mui/icon-button {:label "bearbeiten"
                        :onClick #(swap! vstate/app-state assoc-in [:toe-map :activeUserPopup] cell-data)
                        } [ic-edit/edit {:fontSize "small"}]])))

(defn center-map-renderer [!st]
  (let [!selected (r/cursor !st [:selected])]
    ;(println "center-map-renderer  "  @!selected)
    (fn [js-parm]
      (let [{{lat "addressLatitude" lng "addressLongitude" tomId "tomId"} "rowData" :as d} (js->clj js-parm)]
        (r/as-element
          [mui/icon-button
           {:onClick (fn [_ val]
                       (reset! !selected tomId)
                       (swap! !st assoc-in [:center-map] {:lat lat :lng lng :zoom 17 :mark tomId}))
            } [ic-location-searching/location-searching {:fontSize "small" :color (if (= tomId @!selected) "primary" "inherit")}]
           ])))))


(defn table [!st ]
  (let [!sort (r/cursor !st [:sort])
        !reverse (r/cursor !st [:reverse])
        !elems (r/cursor !st [:elems])
        !centerMap (r/cursor !st [:center-map])
        rows (get-sort-filter-rows @!elems @!sort @!reverse)
        ]
    (fn [m]
      ;(log/debug "öööööööööö öööööööööö rerender !st " (count @!elems) (clj->js m))
      (r/as-element
              [:> rv/Table
               {:headerHeight    50
                :height          500
                :rowCount        (count rows)
                :rowGetter       (fn [i]
                                   ;(println (str "rowGet " (aget i "index")))
                                   (clj->js (nth rows (aget i "index"))))
                :rowClassName    (fn [i] (when (odd? (aget i "index")) "table-odd"))
                :sort            (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection"))))
                :sortBy          @!sort
                :sortDirection   (if @!reverse "DESC" "ASC")
                :rowHeight       45
                :width           (if m (aget m "width") 397)
                ;:onRowClick      (fn [i] (swap! vstate/app-state assoc-in [:toe-map :activeUserPopup] (get (nth rows (aget i "index"))  "id")))
                :onRowDoubleClick   (fn [i]
                                      (let [user (nth rows (aget i "index"))]
                                        (swap! !st assoc-in [:center-map] {:lat (get user "addressLatitude") :lng (get user "addressLongitude")})
                                        ))


                :headerClassName "headerColumn"
                :className       "SmallToeList"}

               [:> rv/Column
                {:label     "TomId"
                 :dataKey   "tomId"
                 :className "bordered exampleColumn"
                 :style     #js {:overflow "hidden"}
                 :width     70}]
               [:> rv/Column
                {:label     "Vorname"
                 :dataKey   "firstName"
                 :className "bordered exampleColumn"
                 :style     #js {:overflow "hidden"}
                 :width     170}]
               [:> rv/Column
                {:label     "Nachname"
                 :dataKey   "lastName"
                 :className "bordered exampleColumn"
                 :width     170}]
               [:> rv/Column
                {:label        (r/as-element [ic-edit/edit])
                 :dataKey      "tomId"
                 :className    "bordered exampleColumn"
                 :cellRenderer edit-cell-renderer
                 :width        70} ]
               [:> rv/Column
                {:label        (r/as-element [ic-location-searching/location-searching])
                 :dataKey      "email"
                 :className    "bordered exampleColumn"
                 :cellRenderer (center-map-renderer !st)
                 :width        70} [:a {:href ""}]]]
              ))))


(defn autoSizer-table [!st]
  [:> rv/AutoSizer
   {:style {:height "550px" :width "100%"}
    :sort (str "rerender !st" @!st)}
   (table !st)])